angular.module('galilai.creator').controller('FastModeController', function ($scope, $timeout, api, $rootScope, $controller, layoutService, parserService) {
    const AMOUNT_PREFETCH = 2
    let publishScope = null
    $scope.publishScope = null
    $scope.state = {
        prefetchedPosts: {},
        post: null,
        pendingPosts: [],
        items: [],
        posts: [],
        parsed: [],
        reloadPosts: false,
    }
    $scope.view = {
        loadingMessage: gettext('label.fast_mode_loading'),
        active: false,
        loading: false,
        tab: 'design',
        filter: {},
        noMorePages: false,
        page: 1,
    }
    $scope.expandedLayouts = []
    $scope.classification = {}

    $rootScope.$on('fastmode.show', function(event, data) {
        let scheduleModal = angular.element('#fastmode-modal')
        scheduleModal.modal('show', {
            backdrop: 'static',
            keyboard: false
        })
        $scope.view.active = true
        // On dismiss call stopMonitoring
        scheduleModal.on('hidden.bs.modal', function() {
            $scope.view.active = false
            try {
                publishScope.stopMonitoring()
                clearRender()
            } catch (error) {
            }
        })
        $scope.state.pendingPosts = data.pendingPosts || []
        if (data.reloadPosts) {
            $scope.state.reloadPosts = true
        }
        $scope.init()
        $scope.loadPost(data.postId)
    })

    function applyChange(size) {
        let mapSizes = {
            'portrait': {
                width: 1,
                height: 1.25
            },
            'story': {
                width: 1,
                height: 1.777777777778
            },
        }
        $scope.state.post.data.theme.size = mapSizes[size]
        $scope.buildPost($scope.state.post)
        $timeout(angular.noop)
    }

    $rootScope.$on('changeFormat', function(event, data) {
        if (!$scope.state.post || !$scope.state.post.data || !$scope.view.active) {
            return
        }
        let format = data.format
        $scope.state.post.data.format = format
        preProcessPost()
    })

    $rootScope.$on('schedule.error', function(event, data) {
        if (!$scope.state.post || !$scope.state.post.data || !$scope.view.active) {
            return
        }
        if (data.kind == 'publish') {
            $scope.view.tab = 'publish'
        } else if (data.kind == 'caption') {
            $scope.view.tab = 'captions'
        }
    })

    function preProcessPost() {
        let format = $scope.state.post.data.format
        if (format == 'story' || format  == 'reels') {
            applyChange('story')
        } else if (format == 'post') {
            const current = $scope.state.post.data.theme && $scope.state.post.data.theme.size
            if (!current || !isFeedPortraitHeight(current.height)) {
                applyChange('portrait')
            }
        }
    }

    $rootScope.$on('captionUpdated', function(event, data) {
        if (!$scope.state.post || !$scope.state.post.data || !$scope.view.active) {
            return
        }
        if (data.caption != $scope.state?.post?.data?.caption) {
            $scope.state.post.data.caption = data.caption
            api.partialUpdatePost($scope.state.post._id, {
                caption: data.caption
            }).catch(function(error) {
            })
        }
    })

    $rootScope.$on('publish.statusUpdated', function(event, data) {
        if (!$scope.view.active || !$scope.state.post) {
            return
        }
        let postId = data.postId
        if (postId && data?.schedule?.status == 'publish') {
            // Remove post from pending posts
            let index = $scope.state.pendingPosts.indexOf(postId)
            if (index > -1) {
                clearRender()
                $scope.nextPost()
                $scope.state.pendingPosts.splice(index, 1)

                if ($scope.state.pendingPosts.length == 0) {
                    showSuccess(gettext('label.all_posts_scheduled'))
                    hideScheduleModal()
                    return
                }
            }

            $rootScope.$broadcast('calendar.loadNewPosts', [postId])
        }
    })

    function hideScheduleModal() {
        let scheduleModal = angular.element('#fastmode-modal')
        scheduleModal.modal('hide')
        // Destroy publish scope
        if (publishScope && publishScope.$destroy) {
            publishScope.$destroy()
            publishScope = null
        }
    }

    function clearRender() {
        $scope.state.items = []
        $scope.state.posts = []
        $scope.state.parsed = []
    }

    function savePostLayouts(post) {
        api.partialUpdatePost($scope.state.post._id, {
            layouts: $scope.state.post.data.layouts
        }).catch(function(error) {
        })
    }

    $scope.buildPost = function(post) {
        $scope.state.parsed = post.data.items.map(function(item, index) {
            post.data.layouts = post.data.layouts || []
            let hasChangedLayouts = false
            post.data.items.map(function(item, index) {
                let layoutId = item.layout || item?.meta?.layout
                item.layout = layoutId
                if (item.layout && !post.data.layouts[index]) {
                    post.data.layouts[index] = layoutService.getExpandedLayout(item.layout)
                    hasChangedLayouts = true
                }
            })
            // If layouts were changed and all items have layouts, we can set the post data layouts
            if (hasChangedLayouts && post.data.items.every(item => item.layout)) {
                savePostLayouts()
            }
            let parsed = parserService.getFullParsed(post, index)

            parsed.extra = {
                selected: false,
            }
            return parsed
        })
        $timeout(angular.noop)
    }

    $scope.init = function() {
        if (publishScope && publishScope.$destroy) {
            publishScope.$destroy()
            publishScope = null
        }
        publishScope = $rootScope.$new(true);
        $controller('PublishController', {
            $scope: publishScope,
        })
        publishScope.setupEvents()
        publishScope.getSocialPages()
        $scope.publishScope = publishScope
    }

    $scope.downloadPost = function() {
        if ($scope.state?.post?.meta?.kind != 'postgen' && !$rootScope.isCustomer(showModal = true, source='Download Post')) {
            return
        }

        if (!$rootScope.isPremiumCustomer() && ($scope?.state?.post?.data?.format == 'reels' || $scope?.state?.post?.data?.mediaFormat == 'video')) {
            $rootScope.showUpgrade('Publish Reels')
            return
        }
        $rootScope.$broadcast('post.download', $scope.state.post)
    }

    $scope.previewPost = function() {
        if ($scope.state?.post?.meta?.kind != 'postgen' && !$rootScope.isCustomer(showModal = true, source='Preview Post')) {
            return
        }
        if (IS_APP) {
            let info = getTokenWithAlert()
            if (!info) return
            window.open(window.BASE_URL + '/preview/?id=' + $scope.state.post._id + '&edit=true' + '&info=' + info, '_blank')
            return
        }
        window.open(window.BASE_URL + '/preview/?id=' + $scope.state.post._id +'&edit=true', '_blank')
    }

    $scope.editPost = function() {
        if ($scope.state?.post?.meta?.kind == 'postgen') {
            $rootScope.$emit('postgen.edit', {
                postId: $scope.state.post._id,
            });
            hideScheduleModal()
            return
        }
        if (!$rootScope.isCustomer(showModal = true, source='Edit Post')) {
            return
        }
        $rootScope.$emit('calendar.editPost', {
            postId: $scope.state.post._id,
        })
        hideScheduleModal()
    }

    function buildLoadingMessage() {
        const keys = [
            'label.fast_mode_loading',
            'label.fast_mode_generating_post',
            'label.fast_mode_generating_layout',
            'label.fast_mode_generating_images',
            'label.fast_mode_caption',
            'label.fast_mode_finalizing'
        ];

        let index = 0;
        let currentMessage = gettext(keys[index]);
        $scope.view.loadingMessage = currentMessage;

        function next() {
            if (!$scope.view.loading) return; // Stop if loading is done
            index++;
            if (index >= keys.length) return;

            const delay = 3000;

            setTimeout(() => {
                // Only update if message hasn't changed externally
                if ($scope.view.loadingMessage === currentMessage) {
                    currentMessage = gettext(keys[index]);
                    $scope.view.loadingMessage = currentMessage;
                    $timeout(angular.noop); // trigger digest
                    next();
                }
            }, delay);
        }

        setTimeout(next, 5000);
    }

    $scope.loadPost = function(postId) {
        function loadPost() {
            $scope.view.loading = true
            $scope.view.loadingPost = true
            buildLoadingMessage()
            api.getPostWithGeneration(postId).then(function(response) {
                $scope.state.post = response.data
                preProcessPost()
                $scope.buildPost($scope.state.post)
                if (publishScope) {
                    publishScope.loadPost($scope.state.post)
                }

                if ($scope.state.reloadPosts) {
                    $scope.state.reloadPosts = false
                    $rootScope.$broadcast('calendar.loadNewPosts', [postId])
                }
            }).catch(function(error) {
                console.error('Error loading post:', error)
                showError(gettext('error.generic'))
            }).finally(function() {
                $scope.view.loading = false
                $scope.view.loadingPost = false
                $timeout(angular.noop)
            })
        }

        layoutService.waitForLayouts().then(() => {
            loadPost()
        })
        .catch((error) => {
            showError(gettext('error.generic'))
        })

        preFetchPosts(postId)
    }

    function preFetchPosts(afterPostId) {
        if (!afterPostId) {
            return
        }
        let index = $scope.state.pendingPosts.indexOf(afterPostId)
        let postsToFetch = []
        for (let i = 1; i <= AMOUNT_PREFETCH; i++) {
            let nextIndex = (index + i) % $scope.state.pendingPosts.length
            let postId = $scope.state.pendingPosts[nextIndex]
            if (!postId) {
                continue
            }
            if (afterPostId == postId) {
                continue
            }
            if (!$scope.state.prefetchedPosts[postId]) {
                postsToFetch.push(postId)
                $scope.state.prefetchedPosts[postId] = true
            }
        }
        // Remove prefetched posts that are already loaded
        for (let i = 0; i < postsToFetch.length; i++) {
            let postId = postsToFetch[i]
            try {
                api.getPostWithGeneration(postId).catch(function(error) {})
            }
            catch (error) {
            }
        }
    }

    $scope.nextPost = function() {
        if ($scope.state.pendingPosts.length == 0) {
            showSuccess(gettext('label.all_posts_scheduled'))
            hideScheduleModal()
            return
        }
        let currentIndex = $scope.state.pendingPosts.indexOf($scope.state.post._id)
        let nextPostIndex = (currentIndex + 1) % $scope.state.pendingPosts.length
        if (nextPostIndex < $scope.state.pendingPosts.length) {
            let nextPostId = $scope.state.pendingPosts[nextPostIndex]
            $scope.loadPost(nextPostId)
        }
    }

    $scope.previousPost = function() {
        if ($scope.state.pendingPosts.length == 0) {
            showSuccess(gettext('label.all_posts_scheduled'))
            hideScheduleModal()
            return
        }
        let currentIndex = $scope.state.pendingPosts.indexOf($scope.state.post._id)
        let previousPostIndex = (currentIndex - 1 + $scope.state.pendingPosts.length) % $scope.state.pendingPosts.length
        if (previousPostIndex >= 0) {
            let previousPostId = $scope.state.pendingPosts[previousPostIndex]
            $scope.loadPost(previousPostId)
        }
    }

    $scope.confirmSchedule = function() {
        if (!$rootScope.isPremiumCustomer()) {
            $rootScope.showUpgrade('Publish Item')
            return
        }
        publishScope.schedulePost({
            'theme.size': $scope.state.post.data.theme.size,
            'format': $scope.state.post.data.format,
        })
    }
})